import { render } from "./PublicationsForm.vue?vue&type=template&id=aa34e5ea&scoped=true"
import script from "./PublicationsForm.vue?vue&type=script&lang=js"
export * from "./PublicationsForm.vue?vue&type=script&lang=js"

import "./PublicationsForm.vue?vue&type=style&index=0&id=aa34e5ea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa34e5ea"]])

export default __exports__